import { AutogenLayoutSMC3ProfileList } from "./autogen/AutogenLayoutSMC3ProfileList";

export class SMC3ProfileList extends AutogenLayoutSMC3ProfileList {
    override onLoad() {
        this.mainDataSource.search({});
    }
}
